import { SECTION_LABELS, TOP_SECTIONS, type DriehoekData } from "../types/driehoek-data";
import { CollapsibleSection } from "./CollapsibleSection";

interface SidebarSectionsProps {
  data: DriehoekData;
  forceOpen?: boolean;
}

export function SidebarSections({ data, forceOpen }: SidebarSectionsProps) {
  return (
    <aside className="cd-sidebar">
      {TOP_SECTIONS.map((section) => {
        const items = data.topSections[section];
        return (
          <CollapsibleSection
            key={section}
            id={`cd-sidebar-${section}`}
            title={SECTION_LABELS[section]}
            variant="sidebar"
            count={items.length}
            defaultOpen={items.length > 0}
            forceOpen={forceOpen}
          >
            <ul>
              {items.map((i) => (
                <li key={i.id}>{i.text}</li>
              ))}
              {items.length === 0 && (
                <li className="cd-sidebar__empty">Nog geen {SECTION_LABELS[section].toLowerCase()}</li>
              )}
            </ul>
          </CollapsibleSection>
        );
      })}
    </aside>
  );
}
